import script from "./CrowdfundingArchive.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingArchive.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingArchive.vue?vue&type=style&index=0&id=51bab8e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bab8e0"]])

export default __exports__